export class Parser {
    protected i = 0;

    constructor(protected data: string) {}

    // ---------------------------------------------------------------------------
    // Range check and data navigation

    public isEnd(): boolean {
        return this.i === this.data.length;
    }

    public reset(): void {
        this.i = 0;
    }

    // ---------------------------------------------------------------------------
    // Look ahead checks

    public nextIsDigit(): boolean {
        return !this.isEnd() && this.isDigit(this.data.charCodeAt(this.i));
    }

    public nextIsAsciiUpper(): boolean {
        return !this.isEnd() && this.isAsciiUpper(this.data.charCodeAt(this.i));
    }

    // ---------------------------------------------------------------------------
    // Reading

    public readInt(): number {
        if (this.isEnd()) {
            throw new Error("Parser: Data ended");
        }

        let digits = "";
        let charCode: number;

        while (
            this.i < this.data.length &&
            this.isDigit((charCode = this.data.charCodeAt(this.i)))
        ) {
            digits += String.fromCharCode(charCode);
            ++this.i;
        }

        return Number.parseInt(digits);
    }

    public readAsciiWord(): string {
        if (this.isEnd()) {
            throw new Error("Parser: Data ended");
        }

        let word = "";
        let charCode: number;

        while (
            this.i < this.data.length &&
            this.isAsciiLetter((charCode = this.data.charCodeAt(this.i)))
        ) {
            word += String.fromCharCode(charCode);
            ++this.i;
        }

        return word;
    }

    public readAsciiUpper(): string {
        if (this.isEnd()) {
            throw new Error("Parser: Data ended");
        }

        let charCode: number;

        if (!this.isAsciiUpper((charCode = this.data.charCodeAt(this.i)))) {
            throw new Error("Parser.readAsciiUpper: Expected 1 char [A-Z]");
        }
        const char = String.fromCharCode(charCode);
        ++this.i;

        return char;
    }

    public readAsciiLower(): string {
        if (this.isEnd()) {
            throw new Error("Parser: Data ended");
        }

        let charCode: number;

        if (!this.isAsciiLower((charCode = this.data.charCodeAt(this.i)))) {
            throw new Error("Parser.readAsciiLower: Expected 1 char [a-z]");
        }
        const char = String.fromCharCode(charCode);
        ++this.i;

        return char;
    }

    // ---------------------------------------------------------------------------
    // Value checks

    protected isDigit(charCode: number): boolean {
        return 48 <= charCode && charCode <= 57;
    }

    protected isAsciiUpper(charCode: number): boolean {
        return 65 <= charCode && charCode <= 90;
    }

    protected isAsciiLower(charCode: number): boolean {
        return 97 <= charCode && charCode <= 122;
    }

    protected isAsciiLetter(charCode: number): boolean {
        return (
            (65 <= charCode && charCode <= 90) ||
            (97 <= charCode && charCode <= 122)
        );
    }
}
